
var ASPECT_PORTRAIT = 0.786;
var ASPECT_LANDSCAPE = 1.273;
var ZOOM_OUT_RATIO = 1;
var rotationAngle = 0;
var initialZoomRatio = 0;
var options = {
    viewMode: 1,
    dragMode: 'move',
    autoCrop: true,
    autoCropArea: 0.85,
    responsive: true,
    restore: false,
    background: false,
    guides: false,
    center: false,
    cropBoxMovable: false,
    cropBoxResizable: false,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: false,
    highlight: false,
    modal: true,
    toggleDragModeOnDblclick: false,
    ready: function(event) {
        $('.button-row').css("visibility", "visible");
    },
    zoom: function(event) {
        //console.log('zoom: ', event.detail.ratio);
        let image = $(this);
        if(event.detail.ratio > event.detail.oldRatio && isPastZoomRate(image)) {
            event.preventDefault();
        }
        else {
            updateFields(image);
            if (initialZoomRatio == 0) {
                    initialZoomRatio = event.detail.oldRatio;
            }
        }
    },
    crop: function(event) {
        updateFields($(this));
    }
};

const TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/heif', 'image/heic'];

function getInputImage(ev) {
    ev.preventDefault();
    if (ev.target.files) {
        const [firstFile] = [...ev.target.files];
        if (TYPES.includes(firstFile.type)) {
            return firstFile;
        }
    }
    return null;
}

function onUploadDrop(ev, imageLoadedDndFn) {
    ev.preventDefault();

    // Ignore drops while the upload instructions overlay is shown (e.g. the
    // user accidentally dragged the instructions image itself) and ignore
    // any drag that doesn't actually carry a real file. In both cases we
    // silently do nothing instead of surfacing an "unsupported image" error.
    if (getUploadInstructionsOverlayVisible() || !isFileDrag(ev)) {
        return;
    }

    imageLoadedDndFn(getDnDImage(ev));
}

function isFileDrag(ev) {
    return !!(ev.dataTransfer && ev.dataTransfer.types && [...ev.dataTransfer.types].includes('Files'));
}

function getUploadInstructionsOverlayVisible() {
    let overlay = $('.pm-upload-instructions-overlay');
    return overlay.length > 0 && !overlay.hasClass('visually-hidden');
}

function getDnDImage(ev) {
    ev.preventDefault();
    if (ev.dataTransfer && ev.dataTransfer.items) {
        const [firstItem] = [...ev.dataTransfer.items];
        if (firstItem.kind === "file" && TYPES.includes(firstItem.type)) {
            return firstItem.getAsFile();
        }
    } else if (ev.dataTransfer && ev.dataTransfer.files) {
        const [firstFile] = [...ev.dataTransfer.files];
        if (TYPES.includes(firstFile.type)) {
            return firstFile;
        }
    }

    return null;
}


function isInvalidImage(img, errorHandler) {

    if (!img || !img.size || !img.type) {
        errorHandler("da.start_invalid_image_format");
        return true;
    }

    if (!TYPES.includes(img.type)) {
        errorHandler("da.start_invalid_image_format");
        return true;
    }

    if (img.size > 104857600) {
        errorHandler("da.start_error_image_too_large");
        return true;
    }

    if (img.size < 100000) {
        errorHandler("da.start_error_image_too_small");
        return true;
    }

    return false;
}

function reportHeifError(apiUrl, uuid, product, img, error, successCallback, failureCallback) {
    const formData = new FormData();
    formData.append('image', img);
    formData.append('product', product);
    formData.append('error', typeof error === 'string' ? error : (error && error.message) || String(error));
    postImage(apiUrl + '/report-heif-error/' + (uuid || 'new'), formData, successCallback, failureCallback);
}

function preloadImage(apiUrl, file, successCallback, failureCallback) {
    const formData = new FormData();
    formData.append('image', file);
    postImage(apiUrl, formData, successCallback, failureCallback);
}

function postJson(apiUrl, jsonData, successCallback, failureCallback)
{
    $.ajax({
        url: apiUrl, 
        type: 'POST',
        data: jsonData,
        contentType: 'application/json; charset=utf-8',
        success: successCallback,
        error: failureCallback
    });
}

function postImage(apiUrl, formData, successCallback, failureCallback)
{
    $.ajax({
        url: apiUrl, 
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        success: successCallback,
        error: failureCallback
    });
}

function getPreloadedImage(apiUrl, successCallback, failureCallback) {
    $.ajax({
        url: apiUrl, 
        method: 'GET',
        xhrFields: {
            responseType: 'blob'
        },
        success: successCallback,
        error: failureCallback
    });
}

function getPreviewImages(apiUrl, successCallback, failureCallback) {
    $.ajax({
        url: apiUrl, 
        method: 'GET',
        success: successCallback,
        error: failureCallback
    });
}

function getJson(apiUrl, successCallback, failureCallback) {
    $.ajax({
        url: apiUrl, 
        method: 'GET',
        success: successCallback,
        error: failureCallback
    });
}

function upLoadImage(apiUrl, successCallback, failureCallback) {
    const formData = new FormData();
    formData.append('x', $('#input_form input[name="x"]').val());
    formData.append('y', $('#input_form input[name="y"]').val());
    formData.append('height', $('#input_form input[name="height"]').val());
    formData.append('width', $('#input_form input[name="width"]').val());
    formData.append('rotate', $('#input_form input[name="rotate"]').val());

    const imageInput = $('#input_image')[0];
    if (imageInput && imageInput.files && imageInput.files[0])
    {
        formData.append('image', imageInput.files[0]);
    }
    postImage(apiUrl, formData, successCallback, failureCallback);
}

function postCode(apiUrl, successCallback, failureCallback)
{
    postJson(apiUrl, JSON.stringify({}), successCallback, failureCallback);
}

function postStyle(apiUrl, effect, canvas, successCallback, failureCallback)
{
    const json = JSON.stringify({
        effect: effect,
        canvas: canvas
    });
    postJson(apiUrl, json, successCallback, failureCallback);
}

function postSelected(apiUrl, selected, lang, successCallback, failureCallback)
{
    const json = JSON.stringify({
        selected: selected,
        lang: lang
    });
    postJson(apiUrl, json, successCallback, failureCallback);
}

function postSend(apiUrl, email, privacyChecked, marketingChecked, prefix, successCallback, failureCallback)
{
    const json = JSON.stringify({
        email: email,
        privacyChecked: privacyChecked,
        marketingChecked: marketingChecked,
        prefix: prefix
    });
    postJson(apiUrl, json, successCallback, failureCallback);
}

function postUpdatePixelBrick(apiUrl, idx, op, successCallback, failureCallback)
{
    const json = JSON.stringify({
        idx: idx,
        op: op
    });
    postJson(apiUrl, json, successCallback, failureCallback);
}

function postPixelBricksWallSize(apiUrl, rows, cols, successCallback, failureCallback)
{
    const json = JSON.stringify({
        rows: rows,
        cols: cols
    });
    postJson(apiUrl, json, successCallback, failureCallback);
}

function postPaintingCanvas(apiUrl, effect, successCallback, failureCallback)
{
    const json = JSON.stringify({
        effect: effect
    });
    postJson(apiUrl, json, successCallback, failureCallback);
}

function postContactMessage(apiUrl, token, formData, successCallback, failureCallback)
{
    const json = JSON.stringify({
        token: token,
        name: formData.get('name'),
        email: formData.get('email'),
        phone: formData.get('phone'),
        subject: formData.get('subject'),
        message: formData.get('message')
    });
    postJson(apiUrl, json, successCallback, failureCallback);
}

function loadHeifImage(img, successCallback, failureCallback) {
    const reader = new FileReader();
    reader.onload = function(e) {
        heic2any({
            blob: img,
            toType: "image/png",
            quality: 0.5
        }).then(function(result) {
            const pngBlob = Array.isArray(result) ? result[0] : result;
            const pngFile = new File([pngBlob], img.name.replace(/\.[^/.]+$/, ".png"), { type: "image/png" });
            successCallback(pngFile);
        }).catch(function(error) {
            // Some files are labelled image/heif or image/heic (e.g. by their
            // file extension) even though their actual content is already a
            // browser-native format (JPEG/PNG/GIF). heic2any detects this via
            // the file's magic bytes and refuses to run the HEIC decoder,
            // rejecting with a message like:
            //   "ERR_USER Image is already browser readable: image/jpeg"
            // In that case there's nothing to convert - just hand back the
            // original file with its real MIME type/extension corrected.
            const alreadyReadableMatch = error && typeof error.message === 'string' &&
                error.message.match(/already browser readable:\s*(\S+)/);
            if (alreadyReadableMatch) {
                const realType = alreadyReadableMatch[1];
                const extension = realType.split('/')[1] || 'jpg';
                const correctedFile = new File([img], img.name.replace(/\.[^/.]+$/, "." + extension), { type: realType });
                successCallback(correctedFile);
                return;
            }
            failureCallback(error);
        });
    };
    reader.readAsArrayBuffer(img);
}

function replaceInputImage(img) {
    if (img) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(img);
        const imageInput = $('#input_image')[0];
        imageInput.files = dataTransfer.files;
    }
}

function loadPreviewImage(file) {
    const preview_image = $("#preview_image");
    const imageReader = new FileReader();
    imageReader.onload = function(event) {
        preview_image.attr('src', event.target.result).fadeIn();
    };
    imageReader.readAsDataURL(file);
}

function previewImage(ev) {
    if (ev.target.naturalHeight * ev.target.naturalWidth > 80000000) {
        onReset(ev);
        showError("da.start_error_image_too_high_resolution");
        return;
    }

    if (ev.target.naturalHeight < 400 || ev.target.naturalWidth < 400) {
        onReset(ev);
        showError("da.start_error_image_too_low_resolution");
        return;
    }

    const image = $('#preview_image');
    init(image);
}

function init(image) {
    cropperDestroy(image);
    var globalImageHolder = image;
    setTimeout(() => {
        cropperCreate(globalImageHolder);
        showPreview();
    });
}

function cropperDestroy(image) {
    image.cropper('destroy');
    initialZoomRatio = 0;
    rotationAngle = 0;
}

function cropperCreate(image) {
    options.aspectRatio = ASPECT_PORTRAIT;
    if(image[0].naturalWidth > image[0].naturalHeight) {
        options.aspectRatio = ASPECT_LANDSCAPE;
    }
    image.cropper(options);
}

function showPreview() {
    let uploadContainer = $('.pm-upload-container');
    let hidden = uploadContainer.hasClass("pm-invisible");
    if (!hidden) {
        uploadContainer.addClass("pm-invisible");
    }
    
    let buttonRow = $('.pm-button-row');
    buttonRow.removeClass('pm-invisible');

    let previewContainer = $('.pm-preview-container');
    previewContainer.removeClass("pm-invisible");

    scrollPreviewIntoView();
    requestAnimationFrame(fitPreviewContainerToScreen);

    document.dispatchEvent(new CustomEvent('pm:preview-shown'));
}

function scrollPreviewIntoView() {
    let previewContainer = $('.pm-preview-container')[0];
    if (previewContainer) {
        previewContainer.scrollIntoView({behavior: 'smooth', block: 'start'});
    }
}

function fitPreviewContainerToScreen() {
    let previewContainer = $('.pm-preview-container')[0];
    if (!previewContainer) {
        return;
    }

    // Reset scale before measuring the container's natural (unscaled) size.
    previewContainer.style.transform = 'none';

    const rect = previewContainer.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) {
        return;
    }

    const availableWidth = window.innerWidth;
    const availableHeight = window.innerHeight;

    const scaleW = availableWidth / rect.width;
    const scaleH = availableHeight / rect.height;
    const scale = Math.min(1, scaleW, scaleH);

    previewContainer.style.transform = scale < 1 ? 'scale(' + scale + ')' : 'none';
}

let fitPreviewContainerToScreenResizeTimeout = null;
window.addEventListener('resize', function() {
    if (fitPreviewContainerToScreenResizeTimeout) {
        clearTimeout(fitPreviewContainerToScreenResizeTimeout);
    }
    fitPreviewContainerToScreenResizeTimeout = setTimeout(fitPreviewContainerToScreen, 150);
});

function hidePreview() {

    let buttonRow = $('.pm-button-row');
    let hidden = buttonRow.hasClass('pm-invisible');
    if (!hidden) {
        buttonRow.addClass('pm-invisible');
    }

    let uploadContainer = $('.pm-upload-container');
    uploadContainer.removeClass("pm-invisible");
}

function showUploadInstructions() {
    $('.pm-upload-instructions-overlay').removeClass('visually-hidden');
}

function hideUploadInstructions() {
    let hidden = $('.pm-upload-instructions-overlay').hasClass('visually-hidden');
    if (!hidden) {
        $('.pm-upload-instructions-overlay').addClass('visually-hidden');
    }
}

function updateFields(image) {
    let cropData = image.cropper('getData');
    let x = Math.round(cropData.x);
    let width = Math.round(cropData.width);
    let y = Math.round(cropData.y);
    let height = Math.round(cropData.height);
    $('input[name="x"]').val(x);
    $('input[name="width"]').val(width);
    $('input[name="y"]').val(y);
    $('input[name="height"]').val(height);
    $('input[name="rotate"]').val(rotationAngle);
}

function isPastZoomRate(image) {
    let cropData = image.cropper('getData');
    if(cropData.width < 200 || cropData.height < 200) {
        return true;
    }
    return false;
}

function zoomImage(image, scale) {
    return image.cropper("zoom", scale);
}

function resetCanvasAndZoom(image) {

    let containerData = image.cropper('getContainerData');
    let containerWidth = containerData.width;
    let containerHeight = containerData.height;

    image = image.cropper("zoomTo", initialZoomRatio, {
        x: containerWidth / 2,
        y: containerHeight / 2
    });

    let canvasData = image.cropper('getCanvasData');
    let canvasWidth = canvasData.width;
    let canvasHeight = canvasData.height;

    let left = Math.round((containerWidth - canvasWidth)/2);
    let right = Math.round((containerHeight - canvasHeight)/2);
    return image.cropper("moveTo", left, right);
}

function resizeCropBox(image) {
    let cropBoxData = image.cropper('getCropBoxData');
    let containerData = image.cropper('getContainerData');
    let containerWidth = containerData.width;
    let containerHeight = containerData.height;
    if(cropBoxData.width > cropBoxData.height) {
        cropBoxData.width = Math.round(containerWidth * ZOOM_OUT_RATIO);
        cropBoxData.height = Math.round(cropBoxData.width/ASPECT_LANDSCAPE);
    }
    else {
        cropBoxData.height = Math.round(containerHeight * ZOOM_OUT_RATIO);
        cropBoxData.width = Math.round(cropBoxData.height*ASPECT_PORTRAIT); 
    }
    image = image.cropper('setCropBoxData', cropBoxData);
    cropBoxData = image.cropper('getCropBoxData');
    cropBoxData.top = Math.round((containerHeight-cropBoxData.height)/2);
    cropBoxData.left = Math.round((containerWidth-cropBoxData.width)/2);
    image = image.cropper('setCropBoxData', cropBoxData);
    return image;
}

function rotateImage(image, angle) {
    rotationAngle = rotationAngle + angle;
    image = image.cropper("rotate", angle);    
    return resetCanvasAndZoom(image);
}

function portraitCropBox(image) {
    image = resetCanvasAndZoom(image);
    image = image.cropper('setAspectRatio', ASPECT_PORTRAIT);
    return resizeCropBox(image);
}

function landscapeCropBox(image) {
    image = resetCanvasAndZoom(image);
    image = image.cropper('setAspectRatio', ASPECT_LANDSCAPE);
    return resizeCropBox(image);
}

function onZoomIn(ev) {
    ev.preventDefault();

    hideMessage();
    let image = $('#preview_image');
    zoomImage(image, 0.1);
}

function onZoomOut(ev) {
    ev.preventDefault();

    hideMessage();
    let image = $('#preview_image');
    zoomImage(image, -0.1);
}

function onRotateLeft(ev) {
    ev.preventDefault();

    hideMessage();
    let image = $('#preview_image');
    rotateImage(image, -90);
}

function onRotateRight(ev) {
    ev.preventDefault();

    hideMessage();
    let image = $('#preview_image');
    rotateImage(image, 90);
}

function onSetPortraitMode(ev) {
    ev.preventDefault();

    hideMessage();
    let image = $('#preview_image');
    portraitCropBox(image);
}

function onSetLandscapeMode(ev) {
    ev.preventDefault();

    hideMessage();
    let image = $('#preview_image');
    landscapeCropBox(image);
}

function onReset(ev) {
    ev.preventDefault();

    hideMessage();
    const image = $('#preview_image');
    cropperDestroy(image);
    image.attr('src', null);
    $("#input_image").val("");
    hidePreview();
    scrollPreviewIntoView();
    requestAnimationFrame(fitPreviewContainerToScreen);
}

function setUuid(uuid) {
    sessionStorage.setItem('uuid', uuid);
}

function getUuid() {
    return sessionStorage.getItem('uuid');
}

function clearUuid() {
    return sessionStorage.removeItem('uuid');
}

function setCode(code) {
    sessionStorage.setItem('code', code);
}

function getCode() {
    return sessionStorage.getItem('code');
}

function removeCode() {
    return sessionStorage.removeItem('code');
}

function setStoredCanvas(canvas) {
    sessionStorage.setItem('canvas', canvas);
}

function getStoredCanvas() {
    return sessionStorage.getItem('canvas');
}

function removeStoredCanvas() {
    return sessionStorage.removeItem('canvas');
}

function setUploadInstructionsShown() {
    sessionStorage.setItem('uploadInstructionsShown', '1');
}

function getUploadInstructionsShown() {
    return sessionStorage.getItem('uploadInstructionsShown');
}

function showMainSpinner() {
    $('.pm-overlay').removeClass('visually-hidden');
}

function hideMainSpinner() {
    let hidden = $('.pm-overlay').hasClass('visually-hidden');
    if (!hidden) {
        $('.pm-overlay').addClass('visually-hidden');
    }
}

function showError(msgCode) {
    showError(msgCode, null);
}

function showError(msgCode, args) {
    hideMessage();
    let msg = translate(msgCode, args);
    let alertMsg = `<div class="alert alert-danger alert-dismissible fade show" role="alert">
        <strong>` + msg + `</strong>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>`;

    $('.pm-error-container').prepend(alertMsg);
}

function showInfo(msgCode) {
    showInfo(msgCode, null);
}

function showInfo(msgCode, args) {
    hideMessage();
    let msg = translate(msgCode, args);
    let infoMsg = `<div class="alert alert-success alert-dismissible fade show" role="alert">
        <strong>` + msg + `</strong>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>`;

    $('.pm-error-container').prepend(infoMsg);
}

function hideMessage() {
    $('.pm-error-container .alert').each(function() {
        var alertInstance = bootstrap.Alert.getInstance(this);
        if (alertInstance) {
            alertInstance.close();
        } else {
            $(this).remove();
        }
    });
}

